import "./resource-show-sidebar.css";
